import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router";

const ServiceFAQ = ({ faq, serviceName }) => {
    const [activeIndex, setActiveIndex] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section
            ref={sectionRef}
            className={`py-16 bg-teal-50 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
            <div className="max-w-6xl mx-auto px-4">
                <h2 className="text-3xl font-bold mb-2 text-teal-600">Common Questions</h2>
                <div className="w-24 h-1 bg-lime-500 mb-12 mt-2"></div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {faq.map((item, index) => (
                        <div
                            key={index}
                            className={`bg-white rounded-xl shadow-md overflow-hidden transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                            style={{ transitionDelay: `${index * 100}ms` }}
                        >
                            <div
                                className="p-6 cursor-pointer flex justify-between items-center"
                                onClick={() => toggleFaq(index)}
                            >
                                <h3 className="text-xl font-semibold text-teal-600">{item.question}</h3>
                                {activeIndex === index ?
                                    <ChevronUp className="h-5 w-5 text-lime-500" /> :
                                    <ChevronDown className="h-5 w-5 text-lime-500" />
                                }
                            </div>

                            <div
                                className={`px-6 overflow-hidden transition-all duration-300 ${activeIndex === index ? 'max-h-40 pb-6' : 'max-h-0'}`}
                            >
                                <p className="text-gray-700">{item.answer}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-12 text-center">
                    <p className="text-lg text-gray-700 mb-6">Have more questions about {serviceName} for dental issues?</p>
                    <Link
                        to='https://wa.me/+918401749379'
                        target="_blank" 
                        className="bg-gradient-to-r from-teal-500 to-lime-500 text-white font-medium py-3 px-8 rounded-full shadow-md transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1">
                        Contact Our Team
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default ServiceFAQ;